(function () {
  function sync(state) {
    var map = {
      "submit-custom-name": state.name,
      "submit-language": state.language,
      "submit-font": state.font,
      "submit-accent": state.accent,
      "submit-position": state.position,
      "submit-notes": state.notes
    };

    Object.keys(map).forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.value = map[id] || "";
    });

    var summary = [];
    if (state.name) summary.push("Name: " + state.name);
    if (state.language) summary.push("Language: " + state.language);
    if (state.font) summary.push("Font: " + state.font);
    if (state.accent) summary.push("Accent: " + state.accent);
    if (state.position) summary.push("Position: " + state.position);
    if (state.notes) summary.push("Notes: " + state.notes);

    var summaryField = document.getElementById("submit-summary");
    if (summaryField) summaryField.value = summary.join(" | ");
  }

  document.addEventListener("DOMContentLoaded", function () {
    if (!window.CustomNecklace) return;
    CustomNecklace.onChange(sync);
    sync(CustomNecklace.get());
  });
})();
